export default "__VITE_ASSET__CfzzD26F__"